import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BASE_URL } from '../config';

export function Button(props) {
  var variant = props.variant || 'primary';
  var size = props.size || 'md';
  var loading = props.loading || false;
  var disabled = props.disabled || false;
  var className = props.className || '';
  var type = props.type || 'button';

  var variantClass = {
    primary: 'btn-primary', secondary: 'btn-secondary',
    danger: 'btn-danger', success: 'btn-success',
    ghost: 'btn-ghost', warning: 'btn-warning',
  }[variant] || 'btn-primary';

  var sizeClass = { sm: 'btn-sm', md: '', lg: 'btn-lg' }[size] || '';

  return React.createElement('button', {
    type: type,
    className: 'btn ' + variantClass + ' ' + sizeClass + ' ' + className,
    onClick: props.onClick,
    disabled: disabled || loading,
    style: props.style,
  }, loading ? React.createElement('span', { className: 'spinner-sm' }) : props.children);
}

export function Badge(props) {
  var variant = props.variant || 'blue';
  var colorClass = {
    green: 'badge-green', red: 'badge-red',
    orange: 'badge-orange', blue: 'badge-blue', gray: 'badge-gray',
  }[variant] || 'badge-blue';
  return React.createElement('span', { className: 'badge ' + colorClass }, props.children);
}

export function StockBadge(props) {
  var status = props.status || 'in_stock';
  if (status === 'out_of_stock') return React.createElement(Badge, { variant: 'red' }, 'Out of Stock');
  if (status === 'low_stock') return React.createElement(Badge, { variant: 'orange' }, 'Low Stock');
  return React.createElement(Badge, { variant: 'green' }, 'In Stock');
}

export function Modal(props) {
  if (!props.isOpen) return null;
  var sizeMap = { sm: '420px', md: '560px', lg: '720px' };
  var maxWidth = sizeMap[props.size] || '560px';
  return React.createElement('div', {
    className: 'modal-overlay',
    onClick: props.onClose,
  },
    React.createElement('div', {
      className: 'modal-box',
      style: { maxWidth: maxWidth },
      onClick: function(e) { e.stopPropagation(); },
    },
      React.createElement('div', { className: 'modal-header' },
        React.createElement('h2', { className: 'modal-title' }, props.title),
        React.createElement('button', { className: 'modal-close', onClick: props.onClose }, 'X')
      ),
      React.createElement('div', { className: 'modal-body' }, props.children)
    )
  );
}

export function StatCard(props) {
  var color = props.color || 'blue';
  return React.createElement('div', { className: 'stat-card stat-' + color },
    React.createElement('div', { className: 'stat-icon' }, props.icon),
    React.createElement('div', { className: 'stat-label' }, props.label),
    React.createElement('div', { className: 'stat-value' }, props.value),
    props.sub ? React.createElement('div', { className: 'stat-sub' }, props.sub) : null
  );
}

export function Spinner(props) {
  var size = props.size || 40;
  return React.createElement('div', { className: 'spinner-wrap' },
    React.createElement('div', { className: 'spinner', style: { width: size, height: size } })
  );
}

export function EmptyState(props) {
  return React.createElement('div', { className: 'empty-state' },
    React.createElement('div', { className: 'empty-icon' }, props.icon || '📭'),
    props.title ? React.createElement('div', { className: 'empty-title' }, props.title) : null,
    props.message ? React.createElement('div', { className: 'empty-msg' }, props.message) : null
  );
}

export function PageHeader(props) {
  return React.createElement('div', { className: 'page-header' },
    React.createElement('div', null,
      React.createElement('h1', { className: 'page-title' }, props.title),
      props.subtitle ? React.createElement('p', { className: 'page-sub' }, props.subtitle) : null
    ),
    props.actions ? React.createElement('div', { className: 'page-actions' }, props.actions) : null
  );
}

export function Sidebar(props) {
  var user = props.user;
  var onLogout = props.onLogout;
  var location = useLocation();
  var path = location.pathname;
  var navItems = [
    { to: '/dashboard', icon: '📊', label: 'Dashboard' },
    { to: '/inventory', icon: '📦', label: 'Inventory' },
    { to: '/customers', icon: '👥', label: 'Customers' },
    { to: '/billing',   icon: '🧾', label: 'Billing' },
    { to: '/invoices',  icon: '📋', label: 'Invoices' },
    { to: '/payments',  icon: '💰', label: 'Payments' },
    { to: '/staff', icon: '👨‍💼', label: 'Staff' },
    { to: '/damaged', icon: '💔', label: 'Damaged Stock' },
    { to: '/offline-sale', icon: '⚡', label: 'Offline Sale' },
    { to: '/reports',   icon: '📈', label: 'Reports' },
  ];
  return React.createElement('aside', { className: 'sidebar' },
    React.createElement('div', { className: 'sidebar-logo', onClick: props.onLogoClick },
      user && user.logo
        ? React.createElement('img', {
            src: BASE_URL + user.logo,
            alt: 'Shop Logo',
            style: { width: 'auto', height: '50px', marginBottom: '8px' }
          })
        : React.createElement('div', { className: 'logo-title' }, '⚡ Bhamsa'),
      // React.createElement('div', { className: 'logo-sub' }, user && user.shop_name ? user.shop_name : 'Inventory Pro v1.0'),
      // React.createElement('div', { style: { fontSize: '10px', color: 'var(--text3)', marginTop: '4px' } }, 'Powered by Bhamsa')
    ),
    React.createElement('nav', { className: 'nav-section' },
      navItems.map(function(item) {
        return React.createElement(Link, {
          key: item.to,
          to: item.to,
          className: path === item.to ? 'nav-item active' : 'nav-item',
        },
          React.createElement('span', { className: 'nav-icon' }, item.icon),
          item.label
        );
      })
    ),
    React.createElement('div', { className: 'sidebar-footer' },
      // React.createElement('div', { className: 'sidebar-user' }, user ? user.name : ''),
      React.createElement('div', { className: 'sidebar-role' }, user && user.role === 'admin' ? '👑 Powered by Bhamsa' : '👤 Staff'),
      React.createElement('button', {
        onClick: onLogout,
        className: 'btn btn-ghost btn-sm',
        style: { marginTop: 10, width: '100%' },
      }, '🚪 Logout')
    )
  );
}